/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aigenerationfailederror3Inputs */

const en_aigenerationfailederror3 = /** @type {(inputs: Aigenerationfailederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI processing failed. No credits were charged - please try again later.`)
};

const de_aigenerationfailederror3 = /** @type {(inputs: Aigenerationfailederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI-Verarbeitung hat nicht geklappt. Es wurden keine Credits abgebucht – versuch's später nochmal.`)
};

/**
* | output |
* | --- |
* | "The AI processing failed. No credits were charged - please try again later." |
*
* @param {Aigenerationfailederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aigenerationfailederror3 = /** @type {((inputs?: Aigenerationfailederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aigenerationfailederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aigenerationfailederror3(inputs)
	return de_aigenerationfailederror3(inputs)
});
export { aigenerationfailederror3 as "aiGenerationFailedError" }